import styled from '@emotion/styled';
import type { FC } from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { QRCode } from '../../BasicComponents/QRCode';

export const QRCodeTab: FC = () => {
  const inspectedTracker = useInspectedTracker();

  if (inspectedTracker == null) return <></>;

  return (
    <Container>
      <QRCode value={`tr.racemap.com/${inspectedTracker.id}`} />
    </Container>
  );
};

const Container = styled.div`
  margin: 15px;
`;
